import type { RuntimeLintContext } from './runtimeRules';

/**
 * The composition as the author wrote it, for rules judging authored markup rather than the loaded
 * state: in the live document GSAP's inline `transform` pose is indistinguishable from a declared
 * one. `innerHTML` runs no scripts, so this parse carries no GSAP-written state.
 */
export function authoredDocument(context: RuntimeLintContext): Document {
    if (!context.sourceHtml) {
        return context.document;
    }
    const parsed = context.document.implementation.createHTMLDocument('');
    parsed.documentElement.innerHTML = context.sourceHtml.replace(/<!DOCTYPE[^>]*>/i, '');
    return parsed;
}

/** Author scripts only — excludes `<script src>` and JSON data blocks, which are not timeline code. */
export function authorScriptText(document: Document): string {
    return Array.from(document.querySelectorAll('script'))
        .filter((script) => !script.getAttribute('src'))
        .map((script) => script.textContent ?? '')
        .join('\n');
}
